import { useEffect, useState } from 'react'
import { addPriceToAdditionalResources } from 'src/components/Education/functions'
import { ICustomPrice } from 'src/interface'
import { useProductPrice } from './useProductPrice'

export const useAdditionalProductPrice = (resources: ICustomPrice[], stripeIds: string[]) => {
  const { prices } = useProductPrice(stripeIds)
  const [additionalResources, setAdditionalResources] = useState(resources)

  useEffect(() => {
    if (prices) {
      const updatedResources = addPriceToAdditionalResources({
        products: additionalResources,
        stripeProducts: prices
      })
      setAdditionalResources(updatedResources)
    }
  }, [prices])

  return { additionalResources }
}
